import { debounce } from 'lodash';

export const debouncedSetName = debounce(
  (value, setName: (value: string) => void) => {
    setName(value);
  },
  600,
);
